import useBlockContext from '../Block/useBlockContext';

const useIsActive = () => {
  // NOTE: there are chances that Img use not only block context in the future
  // as Img theoretically could be the child of other container which might be stateful
  // like CarouselSection
  const blockContext = useBlockContext();
  if (!blockContext) {
    return false;
  }

  return blockContext.isActive;
};

export default useIsActive;
